import React from "react";
import NavBar from "../../NavBar"
import Footer from "../../Footer"
import datiCover from "../../../data/telefonoProdotti.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from "react";
import ScrollabileRiga from "../ScrollabileRiga";
import Selezione from "../Selezione"

export default function Cover(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                
                
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });
    
    const arrId=["Sd","Usb"]    
        
    return (
        <div className="coverBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Prodotti" due="Informazioni" tre="Contattaci" one="/prodotti" two="/informazioni" three="/contattaci"/>
            <h1 className="titoloProdotti">USB e Schede SD</h1>
            <Selezione arr={arrId}/>
            
            <div className="colonna telefoni">

                <ScrollabileRiga idTitolo="Usb" titolo="USB" idScroll1="1" idScroll2="2" dati={datiCover} tipo="memorie" sottoTipo1="usb1" sottoTipo2="usb2" nomeDati="telefonoProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Sd" titolo="Schede SD" idScroll1="3" idScroll2="4" dati={datiCover} tipo="memorie" sottoTipo1="sd1" sottoTipo2="sd2" nomeDati="telefonoProdotti"/>
                
            </div>
            <Footer />
        </div>
    )
}